import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetModule, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { DsButton } from '@frontend/ui/button';
import { DsModal, DsModalContent, DsModalHeader } from '@frontend/ui/modal';
import { DeviceService, DynamicComponentDirective, MenuContentItem } from '@frontend/vanilla/core';
import { AccountMenuRouter } from '@frontend/vanilla/shared/account-menu';

import { AccountMenuItemBase } from '../../account-menu-item-base';

@Component({
    standalone: true,
    imports: [CommonModule, DynamicComponentDirective, MatBottomSheetModule, MatDialogModule, DsModalHeader, DsModal, DsModalContent, DsButton],
    selector: 'vn-wallet-detail.modal',
    templateUrl: './wallet-detail.modal.html',
    providers: [AccountMenuRouter],
    styleUrls: ['../../../../../../../themepark/themes/whitelabel/components/wallet/wallet-detail-modal/styles.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class WalletDetailModalComponent extends AccountMenuItemBase implements OnInit {
    private readonly deviseService = inject(DeviceService);
    bottomSheetRef = inject(MatBottomSheetRef<WalletDetailModalComponent>, { optional: true });
    bottmoSheetdata = inject(MAT_BOTTOM_SHEET_DATA, { optional: true });
    modalDialogref = inject(MatDialogRef<WalletDetailModalComponent>, { optional: true });
    modalDialogData = inject(MAT_DIALOG_DATA, { optional: true });
    data: any;
    items: MenuContentItem[];

    ngOnInit(): void {
        this.data = this.bottmoSheetdata ?? this.modalDialogData;
    }
    close() {
        if (this.deviseService.isMobilePhone) {
            this.bottomSheetRef?.dismiss();
        } else {
            this.modalDialogref?.close();
        }
    }
}
